import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/organizations'

class OrganizationDataService extends RestApiDataService {

}

export default new OrganizationDataService(BASE_ENTITY_URL)
